import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import createAxios from 'utils/axios'
import InputMask from 'react-input-mask'
import { isValidNumber } from 'libphonenumber-js'
import EmailValidation from 'email-validation'

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from 'components/dashboard/constants'

class ActivationCode extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: props.login || '',
      phone: props.login || '86 ',
      mask: '99 999 9999 9999',
      message: '',
      fetching: false,
      disableBtn: false
    }
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  changeHandler(e) {
    const { value } = e.target

    if (value.length > 0 && !/^\w+$/.test(value)) {
      return
    }

    this.props.changeHandler(value.toUpperCase())
    this.setState({ message: '' })
  }

  focusHandler() {
    this.setState({ message: '', disableBtn: false })
  }

  changePhone(e) {
    let phone = e.target.value
    let mask = '99 999 9999 9999'

    if (phone.slice(0, 3) !== '86 ') {
      mask = ''
      phone = phone.replace(/_/g, '').replace(/\s/g, '')
    }

    this.setState({
      phone,
      mask
    })
    this.props.changeLogin(phone.replace(/_/g, ''))
  }

  changeEmail(e) {
    const email = e.target.value
    this.setState({ email })
    this.props.changeLogin(email)
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  submitHandler(e) {
    e.preventDefault()
    const { email, phone } = this.state
    const { region, activationCode } = this.props
    const clearPhone = phone.replace(/[ _]+/g, '')

    if (region === CHINA_REGION && (this.validatePresence(phone) || phone === '86 ')) {
      this.setState({ message: this.t('ActivationCode.FieldsAreRequired') })
      return
    } else if (region === CHINA_REGION && !isValidNumber(`+${clearPhone}`)) {
      this.setState({ message: this.t('Shared.ErrorPhoneMsg') })
      return
    } else if (region !== CHINA_REGION
        && (!EmailValidation.valid(email) || this.validatePresence(email))) {
      this.setState({ message: this.t('Register.EmailWrongFormat') })
      return
    } else if (activationCode.length < 6) {
      this.setState({ message: this.t('ActivationCode.WrongFormat') })
      return
    }

    this.setState({
      message: '',
      fetching: true,
    }, () => {
      this.isCardsExistsRequest()
    })
  }

  validatePresence(value) {
    const re = /^\s+$/

    if (value.length === 0 || re.test(value)) {
      return true
    }
  }

  isCardsExistsRequest() {
    const url = '/tools/cards_exists'
    const payload = {
      params: {
        username: this.props.region === CHINA_REGION
          ? this.state.phone
          : this.state.email,
      }
    }

    this.setState({
      message: '',
      fetching: true,
    })

    this.axios.get(url, payload)
      .then(({ data: { success } }) => {
        if (success) {
          this.props.innerRedirect()
        } else {
          this.activationRequest()
        }
      })
  }

  activationRequest() {
    const url = '/tools/activation'
    const payload = {
      params: {
        activation_code: this.props.activationCode,
      }
    }

    this.setState({ fetching: true })

    this.axios.get(url, payload)
      .then(res => {
        const { data: { region, success } } = res
        if (!success || !region) {
          this.setState({ message: this.t('ActivationCode.WrongFormat'), fetching: false })
        }

        if (success && region) {
          this.setState({ fetching: false }, () => this.props.regionHandler(region))
        }
      })
      .catch(err => {
        if (err.data && err.data.error) {
          this.setState({ message: err.data.error, fetching: false })
        } else {
          this.setState({ message: this.t('ActivationCode.WrongFormat'), fetching: false })
        }
      })
  }

  render() {
    const { activationCode, region } = this.props
    const { message, fetching, phone, email } = this.state
    const img = region === CHINA_REGION ? 'card-back-cn.png' : 'card-back.png'

    return (
      <div className="activation_code">
        <h3><FormattedMessage id="ActivationCode.Header" /></h3>

        <form onSubmit={this.submitHandler.bind(this)} className="form">
          { this.props.region === CHINA_REGION ?
            <div className="form-group form-group-icon activation-input-wrap">
              <InputMask
                type="text"
                name="phone"
                value={phone}
                onChange={this.changePhone.bind(this)}
                onFocus={this.focusHandler.bind(this)}
                placeholder={this.t('Common.Phone')}
                mask={this.state.mask}
                maskChar="_"
              />
              <i className="form-icon form-icon-phone"></i>
            </div>
          :
            <div className="form-group form-group-icon activation-input-wrap">
              <input
                type="text"
                name="email"
                value={email}
                onChange={this.changeEmail.bind(this)}
                onFocus={this.focusHandler.bind(this)}
                placeholder={this.t('Common.Email')}
              />
              <i className="form-icon form-icon-mail"></i>
            </div>
          }

          <div className="form-group form-group-icon activation-input-wrap">
            <input
              type="text"
              name="activationCode"
              maxLength={6}
              value={activationCode}
              onChange={this.changeHandler.bind(this)}
              placeholder={this.t('Common.ActivationCode')}
            />
            <i className="form-icon form-icon-password"></i>
          </div>

          <input
            type="submit"
            disabled={fetching}
            className="button button-dark-blue"
            value={this.t('Common.Next')}
          />
        </form>

        <div className="form__message">
          <small className="error">{ message.length > 0 && message }</small>
          { fetching &&
            <div className="wrapper">
              <div className="cssload-loader"></div>
            </div>
          }
        </div>

        <div className="simcard_hint text-muted">
          <small><FormattedMessage id="ActivationCode.FindActivationCode" /></small>
        </div>
        <br />

        <img src={`/images/${img}`} className="responsive_card" />
      </div>
    )
  }
}

export default injectIntl(ActivationCode)



// WEBPACK FOOTER //
// ./app/javascript/components/application/auth/activation_code.js